import { useState } from 'react';

import { useTranslation } from '../../../../hooks/useTranslation';
import { useQueryStateContext } from '../../../../contexts';
import { useVisualComponentsContext } from '../../../../contexts/visualComponents';
import { useFacetOptions } from '../useFacetOptions';
import { ValidatedMultiStringValueInputProps } from '../types';

export const MultiStringInput = ({
  value,
  onChange,
  isInvalid,
  isOpenByDefault,
  hasWarning,
  dataType,
  field,
  fieldType,
  comparator,
  optionsLimit = 100,
}: ValidatedMultiStringValueInputProps) => {
  const [search, setSearch] = useState('');
  const { t } = useTranslation();
  const { isReadOnly } = useQueryStateContext();
  const { ConditionValueMultiStringInput: VisualComponent } = useVisualComponentsContext();
  const { options, didError, isLoading } = useFacetOptions({ field, dataType });

  const isDisabled = isReadOnly || isLoading || didError;
  const hasError = didError || !!isInvalid;

  return (
    <VisualComponent
      onChange={onChange}
      value={value}
      hasError={hasError}
      hasWarning={hasWarning}
      isOpenByDefault={isOpenByDefault}
      isDisabled={isDisabled}
      dataType={dataType}
      field={field}
      fieldType={fieldType}
      comparator={comparator}
      options={options}
      placeholder={t('v2.conditionBuilder.multiStringPlaceholder')}
      search={search}
      optionsLimit={optionsLimit}
      setSearch={setSearch}
    />
  );
};
